
import React from 'react';
import { Button } from '@/components/ui/button';
import { RefreshCw } from 'lucide-react';
import { toast } from '@/hooks/use-toast';

interface StrikerSwapButtonProps {
  currentStriker: string;
  currentNonStriker: string;
  onSwap: (newStriker: string, newNonStriker: string) => void;
  getPlayerName: (playerId: string) => string;
}

export const StrikerSwapButton: React.FC<StrikerSwapButtonProps> = ({
  currentStriker,
  currentNonStriker,
  onSwap,
  getPlayerName
}) => {
  const handleSwap = () => {
    if (!currentStriker || !currentNonStriker) {
      toast({
        title: "Cannot Swap",
        description: "Both striker and non-striker must be selected",
        variant: "destructive",
      });
      return;
    }

    onSwap(currentNonStriker, currentStriker);
    
    toast({
      title: "Batsmen Swapped",
      description: `${getPlayerName(currentNonStriker)} is now on strike`,
    });
  };

  const isDisabled = !currentStriker || !currentNonStriker;

  return (
    <Button
      variant="outline"
      size="sm"
      onClick={handleSwap}
      disabled={isDisabled}
      className="flex items-center gap-1"
      title="Swap striker and non-striker"
    >
      <RefreshCw className="w-3 h-3" />
      Swap
    </Button>
  );
};
